import React, { useState, useEffect } from 'react';
import './ThinkHRPage.css';
import { useNavigate } from 'react-router-dom';
// import Square from '../assets/group-new.png';
import ThinkHRLogo from '../assets/ThinkHR_Logo-removebg-preview.png';
import module1image from '../assets/HR - Executive Summary.png';
import module2image from '../assets/HR - Analytics Algorithms.png';
import module3image from '../assets/HR - Leave Details.png';
const ThinkHRPage = () => {
  // State for active module
  const navigate =useNavigate()
  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0); // Scroll to top after navigation
  };
  const [activeModuleIndex, setActiveModuleIndex] = useState(0);
  
  // Array of module data with images
  const modules = [
    {
      title: "HR Dashboard Highlights",
      description: "A snapshot of correlated HR metrics provides insights into the organisation, enabling senior executives to leverage these reports for strategic decision-making that enhances overall company performance.",
      image: module1image
    },
    {
      title: "Analytics Algorithms",
      description: "Advanced analytics algorithms process HR data to identify patterns, predict employee behavior, and optimize workforce planning with machine learning technology.",
      image: module2image
    },
    {
      title: "Interactive Dashboard Drilldown",
      description: "Explore detailed employee metrics with interactive visualization tools that allow users to navigate from high-level summaries to granular details for comprehensive analysis.",
      image: module3image
    }
  ];
  
  // Auto-rotate modules every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveModuleIndex((prevIndex) => (prevIndex + 1) % modules.length);
    }, 5000);
    
    return () => clearInterval(interval);
  }, [modules.length]);

  return (
    <div className="think-HR-page">
      {/* Hero Section */}
      <section className="hr-hero-section">
        <div className="hr-hero-content">
          <h1 className="hr-hero-title">
           <img
                className="hr-hero-logo"
                src={ThinkHRLogo}
                alt="ThinkHRLogo"
                />
          </h1>
          <h2 className="hr-hero-subtitle">Prevent talent drain, optimise employee management with functional people analytics</h2>
          <p className="hr-hero-description">
          HR is responsible for managing the employee life. Talent, one of the cornerstones of the balanced scorecard, is the greatest asset in any business. HR analytics determines which data to capture and how to use it to model and predict capabilities, ensuring optimal returns on human capital investments.
          </p>
        </div>
        
        <div className="hr-square-image-frame">
          {/* <img src={Square} alt="hr-Square San" /> */}
        </div>
        <div className="hr-hero-image-container">
          {/* <div className="hr-image-frame">
            <img src={ThinkFinanceLogo} alt="TK" />
          </div> */}
        </div>
        <div className="hr-accent-shape-top-right"></div>
      </section>

      {/* Interactive Modules Section */}
      <section className="hr-modules-section">
        <div className="hr-section-divider">
          {/* <h2 className="hr-section-title-thinkfinance">Available Modules</h2> */}
        </div>
        
        <div className="hr-modules-container">
          {/* Interactive Module List */}
          <div className="hr-module-list">
            {modules.map((module, index) => (
              <div 
                key={index}
                className="hr-module-item"
                onClick={() => setActiveModuleIndex(index)}
              >
                <div className="hr-module-header" style={{ display: 'flex', alignItems: 'flex-start' }}>
                  {/* Blue indicator stick */}
                  <div 
                    className="hr-module-indicator" 
                    style={{ 
                      width: '4px', 
                      height: '30px', 
                      marginRight: '15px',
                      marginTop: '5px',
                      background: activeModuleIndex === index ? '#d4574a' : '#e0e0e0',
                      transition: 'background-color 0.5s ease'
                    }}
                  ></div>
                  
                  {/* Module title */}
                  <h3 style={{ 
                    color: activeModuleIndex === index ? '#000' : '#666',
                    transition: 'color 0.3s ease'
                  }}>
                    {module.title}
                  </h3>
                </div>
                
                {/* Module description (only visible for active module) */}
                {activeModuleIndex === index && (
                  <div 
                    className="hr-module-content" 
                    style={{ 
                      paddingLeft: '19px',
                      marginTop: '10px',
                      maxHeight: '100px',
                      overflow: 'hidden',
                      transition: 'max-height 0.5s ease',
                    }}
                    >
                    <p style={{ fontSize: '16px', lineHeight: '1.6', color: '#555' }}>
                      {module.description}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Dynamic Module Image */}
          <div className="hr-module-image-display">
            <div className="hr-dynamic-module-image-container">
              <img 
                src={modules[activeModuleIndex].image} 
                alt={modules[activeModuleIndex].title}
                className="hr-module-display-image"
              />
              <div className="hr-image-overlay">
                <div className="hr-image-title">
                  {modules[activeModuleIndex].title}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="hr-demo-btn-container">
          <button className="hr-demo-btn" onClick={() => handleNavigate('/contactus')}>Request For Demo</button>
        </div>
        <div className="hr-accent-shape-bottom-right"></div>
      </section>

      <section className="hr-mywave">
        <div className="hr-mywave-content">
          <h2 className="hr-mywave-title"> Boosting emplX with Data Analytics:
             <p>Our Partnership with MyWave</p></h2>
          <p className="hr-mywave-description">
            We are excited to share that we have partnered with MyWave, a leading HRMS company. Our data analytics are now integrated with their HRMS product, emplX. emplX is designed to streamline human resource management processes by automating repetitive tasks and providing deeper insights into employee data. With our analytics
embedded into emplX, users can now access enhanced data-driven decision-making capabilities and optimise resource planning. This seamless partnership combines the strengths of both systems, ensuring a powerful and efficient experience for managing human resources.To learn more about MyWave and their emplX HRMS solution, visit their <a href="https://emplx.com" target="_blank" rel="noopener noreferrer" style={{ color: '#d4574a' }}>website</a>.
          </p>
        </div>
      </section>
    
      {/* Detailed Modules Section */}
      <section className="hr-detailed-modules-section">
        <div className="hr-section-divider">
          <h2 className="hr-section-title-thinkfinance">Available Modules</h2>
        </div>
        
        <div className="hr-modules-grid">
          {/* Module 1 - Headcount */}
          <div className="hr-detailed-module">
            <div className="hr-module-image-container">
              <div className="hr-red-square">
                <svg viewBox="0 0 24 24" width="50%" height="50%" fill="#fff">
                  <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
                </svg>
              </div>
            </div>
            <h3 className="hr-module-title">Headcount</h3>
            <p className="hr-module-description">
              To provide insights on proper deployment of existing people resources for business outcome.
            </p>
          </div>

          {/* Module 2 - Turnover */}
          <div className="hr-detailed-module">
            <div className="hr-module-image-container">
              <div className="hr-red-square">
                <svg viewBox="0 0 24 24" width="50%" height="50%" fill="#fff">
                  <path d="M19 8l-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z"/>
                </svg>
              </div>
            </div>
            <h3 className="hr-module-title">Turnover</h3>
            <p className="hr-module-description">
              Track details leading to attrition and turnover trends, including seasonality, to predict future losses and impact on HR capacity.
            </p>
          </div>

          {/* Module 3 - Leave */}
          <div className="hr-detailed-module">
            <div className="hr-module-image-container">
              <div className="hr-red-square">
                <svg viewBox="0 0 24 24" width="50%" height="50%" fill="#fff">
                  <path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"/>
                </svg>
              </div>
            </div>
            <h3 className="hr-module-title">Leave</h3>
            <p className="hr-module-description">
              Track net effective HR capacity after netting out leave taken by employees and monitor the leave usage in terms of planning, emergency and medical to give valuable insights to work style and challenges of employee.
            </p>
          </div>

          {/* Module 4 - Claim */}
          <div className="hr-detailed-module">
            <div className="hr-module-image-container">
              <div className="hr-red-square">
                <svg viewBox="0 0 24 24" width="50%" height="50%" fill="#fff">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14l2-1.5L7 19l2-1.5L11 19l2-1.5L15 19l2-1.5L19 19V5c0-1.1-.9-2-2-2zm-2 11H7v-2h10v2zm0-4H7V8h10v2z"/>
                </svg>
              </div>
            </div>
            <h3 className="hr-module-title">Claim</h3>
            <p className="hr-module-description">
              Track claim patterns, drilled down to the individual level to give valuable information about employee utilisation on claim benefits.
            </p>
          </div>

          {/* Module 5 - Overtime */}
          <div className="hr-detailed-module">
            <div className="hr-module-image-container">
              <div className="hr-red-square">
                <svg viewBox="0 0 24 24" width="50%" height="50%" fill="#fff">
                  <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
                  <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                </svg>
              </div>
            </div>
            <h3 className="hr-module-title">Overtime</h3>
            <p className="hr-module-description">
              Monitor overtime activities of employees in company and give an alert on abnormally high overtime hours.
            </p>
          </div>

          {/* Module 6 - Payroll */}
          <div className="hr-detailed-module">
            <div className="hr-module-image-container">
              <div className="hr-red-square">
                <svg viewBox="0 0 24 24" width="50%" height="50%" fill="#fff">
                  <path d="M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z"/>
                  
                </svg>
              </div>
            </div>
            <h3 className="hr-module-title">Payroll</h3>
            <p className="hr-module-description">
              Track details of payroll payment and pay scale across different job matrix and department.
            </p>
          </div>

          {/* Module 7 - Retention */}
          <div className="hr-detailed-module">
            <div className="hr-module-image-container">
              <div className="hr-red-square">
                <svg viewBox="0 0 24 24" width="50%" height="50%" fill="#fff">
                  <path d="M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z"/>
                  <path d="M4 19v2h16v-2H4z"/>
                  <path d="M16 13h-3V3h-2v10H8l4 4 4-4z"/>
                </svg>
              </div>
            </div>
            <h3 className="hr-module-title">Retention</h3>
            <p className="hr-module-description">
              Predicts how likely employees are to leave the company by using data patterns of resigned employees to teach our AI engine to recognise similar patterns among current employees.
            </p>
          </div>
        </div>
        <div className="hr-demo-btn-container">
          <button className="hr-demo-btn" onClick={() => handleNavigate('/usecase_hr')}>Learn more about ThinkHR use cases</button>
        </div>
        <div className="hr-accent-shape-bottom-right"></div>
      </section>
    </div>
  );
};

export default ThinkHRPage;